<template>
    <nav class="navbar glass sticky-top">
      <div class="container d-flex justify-content-between align-items-center">
        <router-link to="/" class="navbar-brand">
            Topsail Software Inc.
        </router-link>
        <div class="nav-links">
          <router-link class="nav-link" to="/">Home</router-link>
          <!-- <router-link class="nav-link" to="/portfolio">Portfolio</router-link> -->
          <a href="mailto:contact@topsailsoftware.ca" class="btn-modern sm">Contact</a>
        </div>
      </div>
    </nav>
</template>
  
  <script>
    export default {
      name: 'NavComponent',
      methods: {
      },
      computed: {
      },
      mounted(){
      }
    } 
  </script>
  
  <style scoped>
    .navbar {
        padding: 1rem 0;
        position: sticky;
        top: 0;
        z-index: 1000;
    }

    .navbar-brand {
        font-family: var(--font-heading);
        font-size: 1.5rem;
        color: var(--text-main);
        font-weight: 700;
        text-decoration: none;
    }

    .nav-links {
        display: flex;
        gap: 2rem;
        align-items: center;
    }

    .nav-link {
        color: var(--text-muted);
        font-weight: 500;
        transition: color 0.3s ease;
    }

    .nav-link:hover, .nav-link.router-link-active {
        color: var(--primary);
    }
    
    .btn-modern.sm {
        padding: 8px 16px;
        font-size: 0.9rem;
    }
  </style>